import React from 'react';
import { classes, st } from './AgendaItemOverlay.st.css';
import {
  Avatar,
  AvatarSize,
  Button,
  ButtonSize,
  HoverStyles,
  PaddingModes,
  Text,
  ThumbnailImage,
} from 'wix-ui-tpa/cssVars';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { AgendaItemLayoutProps } from '../const';

export const AgendaItemOverlayLayout: React.FC<AgendaItemLayoutProps> = ({
  agendaItemViewModel,
  onSlotClick,
}) => {
  const {
    serviceName,
    serviceImage,
    startTime,
    duration,
    staffName,
    staffImage,
    location,
    spots,
    price,
    buttonText,
    disabled,
    slotId,
  } = agendaItemViewModel || {};
  const { isMobile } = useEnvironment();

  return (
    <div
      className={st(classes.root, {
        isMobile,
      })}
    >
      <Text className={classes.startTime}>{startTime}</Text>
      <div className={st(classes.content)}>
        <div className={classes.opacityOverlay} />
        <div className={classes.backgroundOverlay} />
        <ThumbnailImage
          fluid
          {...serviceImage}
          className={classes.serviceImage}
        />
        <div className={classes.innerContent}>
          <div className={classes.innerBlockedContent}>
            <div className={classes.leftContent}>
              <div className={st(classes.topWrapper)}>
                <div className={st(classes.nameAndDurationWrapper)}>
                  <Text className={classes.serviceName}>{serviceName}</Text>
                </div>
                <div className={st(classes.staffAndLocationWrapper)}>
                  <div className={classes.staff}>
                    <Avatar
                      className={classes.staffImage}
                      size={AvatarSize.small}
                      src={staffImage}
                      name={staffName}
                    />
                    <Text className={classes.staffName}>{`${staffName}`}</Text>
                    {location && isMobile && (
                      <Text className={classes.splitDot}>•</Text>
                    )}
                  </div>
                  <Text className={classes.location}>{location}</Text>
                  <Text className={classes.duration}>{duration}</Text>
                </div>
              </div>
              <div className={st(classes.bottomWrapper)}>
                <div className={st(classes.priceAndSpotsWrapper)}>
                  <Text className={classes.price}>{price}</Text>
                  <Text className={classes.spots}>{spots}</Text>
                </div>
              </div>
            </div>
            <div className={classes.rightContent}>
              <div className={classes.buttonWrapper}>
                <Button
                  onClick={() => onSlotClick(slotId)}
                  disabled={disabled}
                  className={classes.button}
                  size={ButtonSize.small}
                  paddingMode={PaddingModes.explicitPaddings}
                  hoverStyle={HoverStyles.underline}
                >
                  {buttonText}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
